import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { notification } from '@/app/core/notifications/notification';

import { notificationSuccess } from '../../../../core/toast';
import { useGetFormConnection } from '../../services/signalr.hooks';

export const HandlerLostConnection = ({
  setLoading
}: {
  setLoading: (value: { active: boolean; title: string }) => void;
}) => {
  const connection = useGetFormConnection();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [lostConnection, setLostConnection] = useState(false);
  useEffect(() => {
    connection?.onreconnecting((error) => {
      setLostConnection(true);
      setLoading({ active: true, title: t('formDefinition.label.reconecting') });
    });
  }, [connection, setLoading, t]);

  useEffect(() => {
    connection?.onreconnected((error) => {
      notificationSuccess(t('formDefinition.label.reconected'));
      setLostConnection(false);
      setLoading({ active: false, title: t('formDefinition.label.reconected') });
    });
  }, [connection, setLoading, t]);

  useEffect(() => {
    connection?.onclose((error) => {
      if (lostConnection) {
        notification.error('Connection lost');
        navigate('/');
      }
    });
  }, [connection, lostConnection, navigate]);

  return <></>;
};
